// `dateCreatedGmt` values come back as naive GMT timestamps (no timezone
// suffix) — appending 'Z' mirrors legacy's `convertGmtToLocalTime`, which
// treats the stored value as UTC before rendering in the browser's locale.
export function formatReviewDate(gmt: string): string {
  if (!gmt) return '-'
  const d = new Date(`${gmt}Z`)
  if (Number.isNaN(d.getTime())) return '-'
  return d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
}

export function formatReviewTime(gmt: string): string {
  if (!gmt) return '-'
  const d = new Date(`${gmt}Z`)
  if (Number.isNaN(d.getTime())) return '-'
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
}
